import { ReactElement } from "react";
import HtmlTooltip from "../../components/charts/tooltip";
import { formatTimeWithSeconds } from "../../system/utils";
import KeyValueItem from "../../components/charts/keyValueItem";
import { IVariableGroup } from "../../types";
import { useTheme } from "@mui/material";

interface IProps {
  chartID: string;
  title: string;
  variableGroups: IVariableGroup[];
  y: number;
  xAccessorScaled: (variableGroup: IVariableGroup) => number;
}

const VariablesLayerGantt = ({ variableGroups, chartID, title, y, xAccessorScaled }: IProps): ReactElement => {
  const theme = useTheme();

  return (
    <>
      {variableGroups.map((varGroup, varIndex ) => {
        const sampleKey = `${chartID}-variables-${varIndex}`;

        return (
          <g key={sampleKey}>
            <HtmlTooltip title={
              <div>
                <div className="display-flex-column align-items-center" >
                  <strong>Variable</strong>
                  <strong>{title}</strong>
                  <strong style={{ fontSize: "0.9em" }}>{formatTimeWithSeconds(varGroup.datetime)}</strong>
                </div>
                { varGroup.variables.map((v, i) => {
                  return <KeyValueItem key={`${sampleKey}-${i}`} name={v.name}  value={v.value} unit={v.unit} />;
                })
                }
              </div>
            }>
              <g transform={`translate(${xAccessorScaled(varGroup)}, ${y})`}>
                <polygon fill={"#d84315"} stroke={theme.palette.text.primary}  points="0 0 5 10 10 0 0 0"/>
              </g>
            </HtmlTooltip>
          </g>
        );
      })
      }
    </>
  );
};

export default VariablesLayerGantt;
